import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.id}`}
          className="group relative block h-40 md:h-44 rounded-lg overflow-hidden cursor-pointer"
        >
          <img
            src={cat.cover}
            alt={`${cat.name} 国语对白影音分类`}
            title={`${cat.name} 分类资源合集`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/15" />
          <div className="absolute inset-0 p-5 flex flex-col justify-center">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center shrink-0">
                <i className={`${cat.icon} text-background-50 text-lg`} />
              </span>
              <h3 className="text-base md:text-lg font-bold text-background-50 font-heading">{cat.name}</h3>
            </div>
            <p className="mt-2.5 text-xs md:text-[13px] text-background-200 leading-relaxed line-clamp-2 max-w-sm">
              {cat.description}
            </p>
            <span className="mt-3 inline-flex items-center gap-1 text-xs text-accent-300">
              {cat.count} 部资源
              <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-1" />
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}